var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',[_c('div',{staticClass:"white--text mt-2"},[_vm._v("Treasury Tower Lantai 56 Unit C-1,District 8 @SCBD, Kel. Senayan, Kec. Kebayoran Baru, Kota Adm. Jakarta Selatan, Provinsi DKI Jakarta, Kode Pos: 12190")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }